export default "__VITE_ASSET__rnaNwTle__"